import { z } from "zod";

import type { ID } from "common/utils/models";
import type { models } from "jiffy-api";

export type SizeForm = {
  height: number;
  width: number;
};

export type PlacementForm = {
  artworkId: string;
  size: SizeForm;
  llmRedrawRequestId?: number;
};

export type ArtworkPlacementForm = {
  front: PlacementForm;
  frontLeftChest: PlacementForm;
  back: PlacementForm;
};

export type PlacementInfoForm = {
  enhancementTier: models.cart.madeAdd.EnhancementTier;
  removeBackground: boolean;
  enhancementRequestNote?: string;
  llmRedrawRequestId?: number;
  jiffyDesignServices?: boolean;
  scale?: number;
  editImageManual?: boolean;
};

export type PlacementFormPosition = keyof ArtworkPlacementForm;

export type Side = "front" | "back";

export type ArtworkForm = ArtworkPlacementForm & {
  designProjectUuid: string | undefined;
  currentPlacement: PlacementFormPosition;
  selectedFrontPlacement: PlacementFormPosition;
  info: {
    front: PlacementInfoForm;
    back: PlacementInfoForm;
  };
};

export type CompositionForm = {
  id: ID;
  catalogId: string;
  colorName: string;
  variants: Record<string, number>;
};

export type InventoryError = {
  compositionId: string;
  variantId: string;
  size: string;
  requested: number;
  available: number;
};

export type CompositionsForm = {
  currentCompositionId: ID;
  addedCompositions: CompositionForm[];
  inventoryErrors?: InventoryError[];
};

export type DesignLabFormType = {
  artwork: ArtworkForm;
  compositions: CompositionsForm;
};

export const DesignLabFormSchema = z.object({});
